<template>
    <Dashboard
        :title="__('Dashboard', null, $page.props.profile_locale)"
    >
        <div class="grid lg:grid-cols-4 grid-cols-2 gap-2">
            <MainCard
                icon="cash"
                :title="__('Transactions', null, $page.props.profile_locale)"
                :content="transactions.length"
            >
            </MainCard>
            <MainCard
                icon="cash"
                :title="__('Cash spent', null, $page.props.profile_locale)"
                :content="getPrice(totalSpent, null, false)"
                :class="[
                    $page.props.auth.user.type == 'admin' ? '' : 'lg:col-span-2'
                ]"
            >
            </MainCard>
            <MainCard
                icon="user-group"
                :title="__('Users', null, $page.props.profile_locale)"
                :content="$page.props.users"
                v-if="$page.props.auth.user.type == 'admin'"
            >
            </MainCard>
            <MainCard
                icon="calendar"
                :title="__('Time', null, $page.props.profile_locale)"
                :content="time"
                :class="[
                    $page.props.auth.user.type == 'admin' ? '' : 'lg:col-span-1 col-span-full'
                ]"
            >
            </MainCard>
        </div>
        <div class="overflow-auto w-full mt-4 shadow-md rounded-md">
            <table class="w-full whitespace-nowrap">
                <thead>
                    <tr
                        class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-900 border-red-700">
                        <th class="px-4 py-3">{{__('ID', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Total', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Language', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Status', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Date', null, $page.props.profile_locale)}}</th>
                    </tr>
                </thead>
                <tbody class="bg-white border border-t-0 rounded-b-md">
                    <tr v-for="(transaction, key) in transactions" :key="key"
                        class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400">
                        <td class="px-4 py-3">
                            <div class="flex items-center text-sm">
                                <div>
                                    <p class="font-semibold">#{{transaction.order_nr}}</p>
                                    <p class="text-xs text-gray-600 dark:text-gray-400" v-html="__('Products', null, $page.props.profile_locale) + ': ' + transaction.products.length"></p>
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3 text-sm font-bold">{{ getPrice(transaction.total, transaction.currency) }}</td>
                        <td class="px-4 py-3 text-sm font-bold uppercase">{{ transaction.locale }}</td>
                        <td class="px-4 py-3 text-xs">
                            <span
                                class="px-2 py-1 font-bold leading-tight rounded-full"
                                :class="{
                                    ['bg-red-100 text-red-700'] : transaction.status == 'canceled',
                                    ['bg-green-100 text-green-700'] : transaction.status == 'finished',
                                    ['bg-yellow-100 text-yellow-700'] : transaction.status == 'sent',
                                    ['bg-blue-100 text-blue-700'] : transaction.status == 'in_progress',

                                }"
                                v-html="__('message.' + transaction.status, null, $page.props.profile_locale)"
                            >

                            </span>
                        </td>
                        <td
                            class="px-4 py-3 text-sm"
                            v-html="getDateWithTime(transaction.created_at)"
                        ></td>
                    </tr>
                    <tr v-if="!transactions || transactions && transactions.length == 0">
                        <td class="p-2" colspan="100">{{__("You don't have any orders", null, $page.props.profile_locale)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="mx-auto text-center mt-3" v-if="transactions && transactions.length == 10">
            <Button
                :href="route('dashboard.orders')"
            >{{__('See more')}}</Button>
        </div>

    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import SvgIcon from 'UI/SvgIcon';
    import { ref } from '@vue/reactivity';

    import MainCard from 'CARD/MainCard';
    import Button from 'UI/Button';

    import {
        getOrderPrice,
        getFullTime,
        getPrice,
        getDateWithTime,
    } from 'helper'
import { computed } from '@vue/runtime-core';

    export default {
        props: {
            transactions: Object
        },
        components: {
            Dashboard,
            SvgIcon,
            MainCard,
            Button
        },
        setup(props) {
            const time = ref( getFullTime() );
            setInterval(() => { time.value = getFullTime() }, 1000)


            const cartSum = (key = null) => {
                let sum = 0;

                if (key != null) {
                    props.transactions[key].products.forEach(el => {
                        sum += el.count * el.price;
                    });

                    sum += props.transactions[key].shipping.price;
                }

                else {
                    props.transactions.forEach(el => {
                        el.products.forEach(ell => {
                            sum += ell.count * ell.price;
                        });
                        sum += el.shipping.price;
                    });
                }
                return sum;
            }

            const totalSpent = computed(() => {
                let total = {};
                let a = 0;
                props.transactions.forEach(el => {
                    if(!total[el.currency]) total[el.currency] = 0;
                    total[el.currency] += Number(el.total);

                    a += Number(el.total);
                });
                // return total['EUR'] + '€, ' + total['PLN'] + 'zł';
                return a;
            })

            return {
                cartSum,
                time,
                totalSpent,

                getOrderPrice,
                getFullTime,
                getPrice,
                getDateWithTime,
            }
        },
    }
</script>
